import { render, staticRenderFns } from "./AuthorMain.vue?vue&type=template&id=e61f5480&scoped=true"
import script from "./AuthorMain.vue?vue&type=script&lang=js"
export * from "./AuthorMain.vue?vue&type=script&lang=js"
import style0 from "./AuthorMain.vue?vue&type=style&index=0&id=e61f5480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61f5480",
  null
  
)

export default component.exports